import { useState, type FormEvent } from "react";
import { Link } from "react-router-dom";

import { Button } from "@/components/common";
import { authService } from "@/services/authService";
import "./LoginPage.css";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await authService.forgotPassword(email.trim());
      // Sucesso sempre exibido na resposta 2xx (anti-enumeracao): nao
      // revelamos se o e-mail existe ou nao.
      setSent(true);
    } catch {
      // Falha real de rede/servidor (5xx): sem feedback o usuario nao
      // sabe se deve tentar de novo. Mensagem generica, sem vazar nada.
      setError("Nao foi possivel enviar o link agora. Tente novamente em instantes.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-shell">
      <form className="login-card" onSubmit={onSubmit}>
        <h1 className="login-title">Esqueci a senha</h1>
        {sent ? (
          <>
            <p className="login-sub">
              Se houver uma conta com esse e-mail, enviamos um link para redefinir a senha.
              Verifique sua caixa de entrada.
            </p>
            <Link to="/login" className="login-link">
              Voltar ao login
            </Link>
          </>
        ) : (
          <>
            <p className="login-sub">Informe seu e-mail e enviaremos um link para redefinir a senha.</p>
            <label className="login-field">
              <span>E-mail</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
                autoFocus
              />
            </label>
            {error && (
              <p className="login-error" role="alert">
                {error}
              </p>
            )}
            <Button type="submit" variant="primary" disabled={submitting || !email.trim()}>
              {submitting ? "Enviando…" : "Enviar link"}
            </Button>
            <Link to="/login" className="login-link">
              Voltar ao login
            </Link>
          </>
        )}
      </form>
    </div>
  );
}
